/**
 * Trailing-edge debounce of a value. Starts equal to the input, so the first
 * render (and therefore the first fetch) is never delayed.
 *
 * Used to keep a search input instantly responsive while the data hooks it
 * feeds — each of which disposes its row cache and reloads from page one —
 * only see the value the user paused on.
 */
import { useEffect, useState } from 'react'

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    if (Object.is(value, debounced)) return
    const timer = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, debounced, delayMs])

  return debounced
}
